export const type = [
  { type: 'JX', name: '视觉精细', color: '#ff4d94' },
  { type: 'CJ', name: '视觉刺激', color: '#3ECC88' },
  { type: 'TYZ', name: '同时视B', color: '#00C7FF' },
  { type: 'RH', name: '集合训练', color: '#BF90FF' },
  { type: 'SK', name: '散开训练', color: '#BF90FF' },
  { type: 'TSS', name: '同时视', color: '#FE8347' },
  { type: 'LTS', name: '立体视', color: '#FCCE19' },
  { type: 'OH', name: '其他', color: '#FCCE19' },
  // { type: '3D', name: '3D训练', color: '#FCCE19' },
  { type: '3DR', name: '3D融合', color: '#FCCE19' },
  { type: '3DF', name: '3D防控', color: '#FCCE19' },
  { type: '3DS', name: '3D视频', color: '#FCCE19' },
  { type: 'JTTJ', name: '调节训练' },
]

export const eyeSight = [
  0.1,
  0.12,
  0.15,
  0.2,
  0.25,
  0.3,
  0.4,
  0.5,
  0.6,
  0.8,
  1.0,
  1.2,
  1.5,
  2.0,
]
